import React from 'react';
import ReactMarkdown from 'react-markdown';
import Projects from './Projects';
import './Container.css';

const Container = ({ company }) => {
  const {
    id,
    orientation,
    title,
    body,
    type,
    avatar,
    projects,
    dates
  } = company;
  const containerClasses = ['container'];

  if (orientation) {
    containerClasses.push(orientation);
  }

  containerClasses.push(type)

  return (
    <div
      {...(id, { id }, {})}
      className={containerClasses.join(' ')}
    >
      <div className="content">
        {avatar ? <img alt="Avatar" src={avatar} className="avatar" /> : ''}
        <h2>{title}</h2>

        <ReactMarkdown
          source={body}
          escapeHtml={false}
          linkTarget="_blank"
        />

        <div>{dates}</div>

        {projects && (
          <Projects data={projects} />
        )}
      </div>
    </div >
  );
}

export default Container;
